const STORAGE_KEY = "last_auth_method";

export type AuthMethod = "google" | "password";

export function getLastAuthMethod(): AuthMethod | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === "google" || value === "password") return value;
    return null;
  } catch {
    return null;
  }
}

export function saveLastAuthMethod(method: AuthMethod): void {
  try {
    localStorage.setItem(STORAGE_KEY, method);
  } catch {
    // no storage
  }
}
